import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  subList: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  auths: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  unAuths: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  competitors: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  unCompetitors: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  detail: { data: null, loading: false },
  dialog: { visible: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
